import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import SearchToolbar from "../toolbars/SearchToolbar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useLayoutContext } from "@ntg/component-library/contexts";
import { useNavigate } from "react-router-dom";
import { useSearchForServiceOrderHeaders } from "../hooks/ServiceOrder/useSearchForServiceOrderHeaders";

import Chip from "@mui/material/Chip";

type StatusChipConfig = { label: string; color?: "default" | "warning" | "info" | "success"; sx?: object };

const SALES_STATUS_CHIPS: Record<number, StatusChipConfig> = {
    0: { label: "None", color: "default" },
    1: { label: "Backorder", color: "warning" },
    2: { label: "Delivered", color: "info" },
    3: { label: "Invoiced", color: "success" },
    4: { label: "Canceled", sx: { backgroundColor: "#616161", color: "#fff" } },
};

export default function ServiceOrderSearchContainer() {
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
    const [searchTerm, setSearchTerm] = React.useState<string>("");
    const navigate = useNavigate();
    const { data: searchResults, isLoading } =
        useSearchForServiceOrderHeaders(searchTerm);

    useEffect(() => {
        SetPrimaryTitle("Service Order Overview");
        SetSecondaryHeader(
            <SearchToolbar
                domain="ServiceOrder"
                onSearch={(term) => setSearchTerm(term)}
            />,
        );
        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
            setSearchTerm("");
        };
    }, [SetPrimaryTitle, SetSecondaryHeader]);

    if (isLoading) return <p>Loading…</p>;

    return (
        <TableContainer component={Paper}>
            <Table className="foTable">
                <TableHead>
                    <TableRow>
                        <TableCell>Order</TableCell>
                        <TableCell>Created</TableCell>
                        <TableCell>Contact</TableCell>
                        <TableCell>Boat</TableCell>
                        <TableCell>D365 Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {searchResults?.map((order) => (
                        <TableRow key={order.serviceOrderID}>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() =>
                                        navigate(
                                            `/ServiceOrderHeader/${order.serviceOrderID}`,
                                        )
                                    }
                                >
                                    {order.coServiceOrderID}
                                </Button>
                            </TableCell>
                            <TableCell>
                                {order.createdDate
                                    ? new Date(order.createdDate).toLocaleDateString()
                                    : ""}
                            </TableCell>
                            <TableCell>{order.contact}</TableCell>
                            <TableCell>{order.boat}</TableCell>
                            <TableCell>
                                {order.salesStatusID != null && (() => {
                                    const cfg = SALES_STATUS_CHIPS[order.salesStatusID];
                                    return cfg
                                        ? <Chip label={cfg.label} size="small" color={cfg.color} sx={cfg.sx} />
                                        : <Chip label={`Unknown (${order.salesStatusID})`} size="small" />;
                                })()}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={5}>
                            {searchResults && searchResults.length ? (
                                <span>{searchResults.length}</span>
                            ) : (
                                <span>No</span>
                            )}{" "}
                            results
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
